const ReviewerProfileMain = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-reviewer/reviewer-profile/ReviewerProfileMain.vue"
  );
const ReviewerProfileDomains = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-reviewer/reviewer-profile/ReviewerProfileDomains.vue"
  );
const ReviewerProfileContracts = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-reviewer/reviewer-profile/ReviewerProfileContracts.vue"
  );
export default [
  {
    path: "",
    name: "reviewer-profile",
    redirect: { name: "reviewer-profile-main" },
  },
  {
    path: "personal",
    name: "reviewer-profile-main",
    component: ReviewerProfileMain,
  },
  {
    path: "domains",
    name: "reviewer-profile-domains",
    component: ReviewerProfileDomains,
  },
  {
    path: "contracts",
    name: "reviewer-profile-contracts",
    component: ReviewerProfileContracts,
  },
];
